/* eslint-disable @typescript-eslint/no-explicit-any */
import { Address } from '@ecm/data/Address'

export const updateMapBounds = (addresses: Address[], map?: google.maps.Map) => {
  if (!map) {
    return
  }

  const bounds = new google.maps.LatLngBounds()

  addresses.map((a: Address) => {
    bounds.extend(a.location)
  })

  const offset = 0
  const centerLoc = bounds.getCenter()
  bounds.extend(new google.maps.LatLng(centerLoc.lat() + offset, centerLoc.lng() + offset))
  bounds.extend(new google.maps.LatLng(centerLoc.lat() - offset, centerLoc.lng() - offset))
  map.fitBounds(bounds)
}
